import { isNil } from '@lucidlink/tscore';
import { webCrypto } from '#web-crypto';
import { arrayToBase64, base64ToArray } from './binary-utils';
import { AES_CRYPTO_IV_LENGTH, AES_CRYPTO_KEY_BITS, AES_ENCRYPTION_ALGO_PARAMS, AES_KW_ENCRYPTION_ALGO_PARAMS, } from './constants';
import { generateRandomBytes } from './random';
export const encryptWithAesRaw = async (buffer, aesKey, iv) => {
    if (isNil(iv)) {
        iv = generateRandomBytes(AES_CRYPTO_IV_LENGTH);
    }
    const encrypted = await webCrypto.subtle.encrypt({
        name: aesKey.algorithm.name,
        iv,
        length: AES_CRYPTO_KEY_BITS,
    }, aesKey, buffer);
    const ivView = new Uint8Array(iv);
    const encryptedView = new Uint8Array(encrypted);
    const result = new Uint8Array(iv.byteLength + encrypted.byteLength);
    result.set(ivView, 0);
    result.set(encryptedView, ivView.byteLength);
    return result;
};
export const encryptWithAes = async (buffer, aesKey, iv) => arrayToBase64(await encryptWithAesRaw(buffer, aesKey, iv));
export const decryptWithAes = async (base64Input, aesKey) => {
    const input = base64ToArray(base64Input);
    const ivView = new Uint8Array(input, 0, AES_CRYPTO_IV_LENGTH);
    const encryptedView = new Uint8Array(input, AES_CRYPTO_IV_LENGTH);
    const decryptedData = await webCrypto.subtle.decrypt({ name: aesKey.algorithm.name, iv: ivView }, aesKey, encryptedView);
    return {
        iv: ivView.buffer.slice(ivView.byteOffset, ivView.byteLength + ivView.byteOffset),
        buffer: decryptedData,
    };
};
export const generateAesGcmKey = async () => {
    return await webCrypto.subtle.generateKey(AES_ENCRYPTION_ALGO_PARAMS.algorithm, true, ['encrypt', 'decrypt']);
};
export const generateAesKwKey = async () => {
    return await webCrypto.subtle.generateKey(AES_KW_ENCRYPTION_ALGO_PARAMS.algorithm, true, ['wrapKey', 'unwrapKey']);
};
